import React from 'react'
import { useNavigate } from 'react-router-dom'

const Card = ({ title, content, lcolor, icon: Icon, link, buttonText = "Learn More", onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (link) {
      navigate(link);
    }
  };

  return (
    <div className='group relative bg-gray-100 dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-200 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 ease-out transform hover:-translate-y-2 hover:scale-[1.02] border border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 overflow-hidden w-full max-w-sm mx-auto'>
      {/* Gradient Overlay */}
      <div className='absolute inset-0 bg-gradient-to-br from-blue-50 to-transparent dark:from-blue-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>

      {/* Animated Border */}
      <div className='absolute inset-0 rounded-xl border-2 border-transparent bg-gradient-to-r from-blue-300 to-indigo-300 dark:from-blue-600 dark:to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10'></div>      <div className='relative p-8'>
        {/* Icon and Title */}
        <div className='flex items-center gap-3 mb-4'>
            <div className='p-3 bg-blue-50 dark:bg-blue-900/30 rounded-lg group-hover:bg-gray-100 dark:group-hover:bg-gray-200 transition-colors duration-300'>
              <Icon size={24} className='text-blue-600 dark:text-blue-400 group-hover:text-gray-800 dark:group-hover:text-gray-700 group-hover:scale-110 transition-all duration-300' />
            </div>
          <h3 className='font-bold text-xl text-gray-800 dark:text-gray-100 group-hover:text-gray-900 dark:group-hover:text-gray-800 transition-colors duration-300'>
            {title}
          </h3>
        </div>
        
        {/* Content */}
        <div className='text-gray-600 dark:text-gray-200 group-hover:text-gray-800 dark:group-hover:text-gray-700 mb-6 leading-relaxed'>
          {typeof content === 'string' ? <p>{content}</p> : content}
        </div>
        
        {/* Enhanced Button */}
        <button 
          onClick={handleClick}
          className={`relative w-full px-6 py-3 text-white font-semibold rounded-lg transition-all duration-300 transform group-hover:scale-[1.02] overflow-hidden ${lcolor}`}
        >
          {/* Button shine effect */}
          <div className='absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-out'></div>
          
          <span className='relative flex items-center justify-center gap-2'>
            {buttonText}
            <svg 
              className='w-4 h-4 transition-transform duration-300 group-hover:translate-x-1' 
              fill='none' 
              stroke='currentColor' 
              viewBox='0 0 24 24'
            >
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
            </svg>
          </span>
        </button>
      </div>
      
      {/* Floating particles effect */}
      <div className='absolute top-4 right-4 w-2 h-2 bg-blue-400 dark:bg-blue-500 rounded-full opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300'></div>
      <div className='absolute top-8 right-8 w-1 h-1 bg-indigo-400 dark:bg-indigo-500 rounded-full opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300 delay-150'></div>
    </div>
  )
}

export default Card
